import { useState } from "react";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";

const FormCrearVendedor = () => {
  const { token } = useAuth();

  const [formData, setFormData] = useState({
    nombre_user: "",
    apellido_user: "",
    email_user: "",
    password_user: "",
    confirmar_password: "",
  });

  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      nombre_user,
      apellido_user,
      email_user,
      password_user,
      confirmar_password,
    } = formData;

    if (!nombre_user || !apellido_user || !email_user || !password_user || !confirmar_password) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    if (password_user !== confirmar_password) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    setError("");
    setMensaje("");

    try {
      await axios.post(
        `${import.meta.env.VITE_API_URL}/user/`,
        {
          nombre_user,
          apellido_user,
          email_user,
          password_user,
          role: "seller",
        },
        {
          headers: {
            "x-auth-token": token,
          },
        }
      );

      setMensaje("Vendedor creado con éxito.");
      setFormData({
        nombre_user: "",
        apellido_user: "",
        email_user: "",
        password_user: "",
        confirmar_password: "",
      });
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data === "El usuario o correo electrónico ya existe"
          ? "El email ya está registrado"
          : "Error al crear el vendedor"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Crear Vendedor</h2>

        {mensaje && <div className="text-green-600 mb-4">{mensaje}</div>}
        {error && <div className="text-red-600 mb-4">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block font-semibold mb-1">Nombre</label>
            <input
              type="text"
              name="nombre_user"
              value={formData.nombre_user}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block font-semibold mb-1">Apellido</label>
            <input
              type="text"
              name="apellido_user"
              value={formData.apellido_user}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block font-semibold mb-1">Email</label>
            <input
              type="email"
              name="email_user"
              value={formData.email_user}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block font-semibold mb-1">Contraseña</label>
            <input
              type="password"
              name="password_user"
              value={formData.password_user}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block font-semibold mb-1">Confirmar contraseña</label>
            <input
              type="password"
              name="confirmar_password"
              value={formData.confirmar_password}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              {loading ? "Creando..." : "Crear Vendedor"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormCrearVendedor;
